import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import helpers from 'dom-helpers';
import { TranslationProvider } from './ChildrenContext';

class Dropdown extends React.Component {
    constructor(props) {
      super();

      this.state = {
          open: !!props.open,
          isCloseDocument: props.isCloseDocument,
          overlay: props.overlay
      };
    }

    componentDidMount() {
        this.initChildren();

        this.state.isCloseDocument && document.body.addEventListener('click', this.onClickDocument.bind(this));
        this.wrapper && window.addEventListener('resize', this.setPositionWrapper.bind(this));
    }

    componentWillUnmount() {
        this.state.isCloseDocument && document.body.removeEventListener('click', this.onClickDocument);
        this.wrapper && window.removeEventListener('resize', this.setPositionWrapper);

        this.removeChildren();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== undefined) {
            this.setState({
                open: nextProps.open
            });
        }
    }

    componentDidUpdate() {
        this.renderChildren();
    }

    getClass(key, cl) {
        return classNames({
            ...this.props[key],
            ...cl
        });
    }

    setPositionWrapper() {
        if (!this.refs.element) {
            return;
        }

        const elemBox = helpers.offset(this.refs.element);

        helpers.style(this.wrapper, {
            position: 'absolute',
            top: (elemBox.top + elemBox.height / 2) + 'px',
            left: elemBox.left + 'px',
            zIndex: 100
        });
    }

    onClickDocument(event) {
        if (!this.state.open) {
            return;
        }

        if (event.target.closest('.sidebar') || event.target.closest('.bm-menu') || event.target.closest('.top-header__menu-toggle')) {
            this.onToggle(event);
            return;
        }

        let elem = event.target.closest('.dropdown');

        if (!(elem === this.refs.element || elem === this.wrapper)) {
            this.onToggle(event);
        }
    }

    isTrustedEvent(event) {
        if (!event) {
            return false;
        }

        const nativeEvent = event.nativeEvent || event;

        if (typeof nativeEvent.isTrusted === 'boolean') {
            return nativeEvent.isTrusted;
        }

        return true;
    }

    onToggle(event) {
        const shouldCloseSidebar = (
            event &&
            event.target &&
            null === event.target.closest('.bm-menu') &&
            this.isTrustedEvent(event)
        );

        if (shouldCloseSidebar) {
            let activeHamburger = document.querySelector('.top-header__menu-toggle.active');
            if (null !== activeHamburger) {
                document.querySelector('.top-header__menu-toggle.active').click();
            }
        }
        if (this.props.onToggle) {
            this.props.onToggle();
            return;
        }

        this.setState( prevState => {
            return { open: !prevState.open }
        });
    }

    initChildren() {
        if (this.state.overlay !== 'body') {
            return;
        }

        this.wrapper = document.createElement('div');
        const body = helpers.querySelectorAll(document, 'body')[0];

        body.appendChild(this.wrapper);

        this.renderChildren();
    }

    removeChildren() {
        if (!this.wrapper) {
            return;
        }

        ReactDOM.unmountComponentAtNode(this.wrapper);
        this.wrapper.parentNode.removeChild(this.wrapper);
    }

    renderChildren() {
        if (!this.wrapper) {
            return;
        }

        this.setPositionWrapper();

        this.wrapper.className = classNames({
            'dropdown': true,
            'open': this.state.open
        });

        ReactDOM.render(
            <TranslationProvider>
                {this.props.children}
            </TranslationProvider>, this.wrapper
        );
    }

    render() {
        return (
            <div
                className={this.getClass('mainClass', {'dropdown': true, 'open': this.state.open})}
                ref={'element'}
            >
                <button
                    className={this.getClass('headerClass', {'dropdown-toggle': true, 'btn-empty': true, 'bold': true})}
                    onClick={this.onToggle.bind(this)}
                >
                    {this.props.header}
                </button>
                {(!this.wrapper && this.state.open) ? this.props.children : null}
            </div>
        )
    }
}

Dropdown.propTypes = {
    mainClass: PropTypes.object,
    headerClass: PropTypes.object,
    open: PropTypes.bool,
    onToggle: PropTypes.func,
    isCloseDocument: PropTypes.bool,
    overlay: PropTypes.string,
    header: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ])
};

Dropdown.defaultProps = {
    dropdown: false,
    isCloseDocument: true,
    header: '',
    overlay: '',
    headerClass: {},
    mainClass: {}
};

Dropdown.contextTypes = {
    t: PropTypes.object
};

export default Dropdown;
